export const QuantityUnits = [
  { value: "permun", label: "Mun" },
  { value: "perkg", label: "KG" },
  { value: "perliter", label: "Liter" },
  { value: "perkanal", label: "Kanal" },
  { value: "perbag", label: "Bag" },
  { value: "perunit", label: "Unit" },
  { value: "notapp", label: "Not applicable" },
];
